import { useScrollReveal } from "@/hooks/useScrollReveal"
import {GraduationCap, MessageCircleDashed as MessageCircle, Video, Smartphone, Trophy} from 'lucide-react'

const cards = [
  {
    icon: GraduationCap,
    title: "Formação Profissional Completa",
    desc: "+500 horas de conteúdo estruturado para áreas como saúde, negócios, viagens, tecnologia e muito mais.",
    highlight: "Isso não é curso genérico. É inglês aplicado à vida real.",
    color: "#F5C542",
  },
  {
    icon: MessageCircle,
    title: "Tutora 24h no WhatsApp",
    desc: "Pratique inglês todos os dias, tire dúvidas na hora e evolua com segurança.",
    highlight: "Você nunca estuda sozinho.",
    color: "#F5C542",
  },
  {
    icon: Video,
    title: "Aulas ao Vivo Semanais",
    desc: "Treine conversação, escuta e confiança com acompanhamento real.",
    highlight: "",
    color: "#F5C542",
  },
  {
    icon: Smartphone,
    title: "Estude Onde Quiser",
    desc: "App iOS e Android + material digital incluso.",
    highlight: "",
    color: "#F5C542",
  },
  {
    icon: Trophy,
    title: "Certificado Gratuito",
    desc: "Conclua seu nível e receba seu certificado sem custo adicional.",
    highlight: "",
    color: "#F5C542",
  },
]

export default function EcosystemSection() {
  const { ref, isVisible } = useScrollReveal()

  return (
    <section id="ewpass" className="relative py-20 md:py-28 text-white overflow-hidden" style={{ backgroundColor: "#0E8EA0" }}>
      {/* Decorative shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full opacity-10" style={{ backgroundColor: "#fff" }} />
        <div className="absolute bottom-10 -left-16 w-60 h-60 rounded-full opacity-10" style={{ backgroundColor: "#B038B2" }} />
      </div>

      <div ref={ref} className="relative z-10 max-w-7xl mx-auto px-5">
        <div
          className={`text-center mb-6 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-4">
            Conheça o <span style={{ color: "#F5C542" }}>EW Pass</span>
          </h2>
          <p className="text-white/90 text-xl md:text-2xl font-semibold max-w-3xl mx-auto leading-relaxed mb-4">
            Você não vai estudar sozinho. Você vai conversar, praticar e evoluir todos os dias.
          </p>
          <p className="text-white/80 text-lg max-w-2xl mx-auto leading-relaxed">
            A plataforma completa de inglês da English Work. Tudo o que você precisa
            para aprender de forma estruturada, prática e contínua.
          </p>
        </div>

        {/* Badge */}
        <div
          className={`flex justify-center mb-14 transition-all duration-700 delay-200 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/15 backdrop-blur-sm">
            <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: "#F5C542" }} />
            <span className="text-white font-semibold text-sm">Plataforma completa de inglês</span>
          </div>
        </div>

        {/* Cards grid - 2 per row */}
        <div className="grid sm:grid-cols-2 gap-5">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className={`bg-white/10 backdrop-blur-sm rounded-2xl p-7 border border-white/15 hover:bg-white/20 hover:-translate-y-1 transition-all duration-500 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
              }`}
              style={{ transitionDelay: isVisible ? `${(i + 1) * 100}ms` : "0ms" }}
            >
              <div className="flex items-start gap-4">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center shrink-0"
                  style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
                >
                  <card.icon size={26} className="text-white" />
                </div>
                <div>
                  <h4 className="text-white font-bold text-lg mb-1">{card.title}</h4>
                  <p className="text-white/70 text-sm leading-relaxed">{card.desc}</p>
                  {card.highlight && (
                    <p className="text-sm font-semibold mt-2" style={{ color: "#F5C542" }}>
                      👉 {card.highlight}
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 40L80 45C160 50 320 60 480 58C640 56 800 42 960 36C1120 30 1280 32 1360 33L1440 34V80H0V40Z" fill="white"/>
        </svg>
      </div>
    </section>
  )
}
